<template>
  <div class="lc_loaderBtn TQ_clickable">
    <div v-if="!showLoader && text" class="TQ_btn"
         :class="btnClass"
         @click="$emit('clickBtn')" >
      {{text}}
    </div>
    <!--loader-->
    <div  v-if="showLoader" >
      <ball-pulse-loader :color="p_loaderColor_s" size="10px"></ball-pulse-loader>
    </div>

    <slot v-if="!showLoader" />

  </div>
</template>

<script>
    import {BallPulseLoader} from 'vue-loaders'

    export default {
        name: "TqLoaderButton",
        props:{
            showLoader: {
                type: Boolean,
                require : true
            },
            text: {
                type : String,
            },
            btnClass:{
                type: String
            },
            p_loaderColor_s:{
                type: String,
                default: '#2E294E'
            }

        },
        components:{
            BallPulseLoader
        }
    }
</script>

<style scoped>
  .lc_loaderBtn{
    display: inline-block;
  }
</style>
